export default __webpack_public_path__ + "static/media/ach.8773582f.svg";